import {
  Language,
  LanguagesMap,
  LanguageCodes,
  OperatorKeys,
  OperatorLanguagesMap
} from "../types";

const languages: LanguagesMap = {
  "en-us": {
    headerLineOne: "Upcoming Wagers",
    headerLineTwo: "",
    marketNames: {
      moneyline: "Moneyline",
      spread: "Spread",
      Spread: "Spread",
      handicapBetting: "Spread",
      matchWinner: "Moneyline",
      totals: "Totals",
      overUnderTotals: "Totals",
      firstGoalscorer: "First Goalscorer",
      competitionWinner: "Competition Winner",
      fullTimeResult: "Match",
      "NBA Championship Winner": "NBA Championship Winner",
      "NBA Conference Winner": "NBA Conference Winner",
      "Money Line": "Money Line",
      "Total Points": "Total Points",
      "Conference Winner": "Conference Winner",
      "Money Line Live": "Money Line Live",
      "Odds Boost": "Odds Boost",
      "Tournament Winner": "Tournament Winner",
      "Match Betting": "Match Betting",
      "Bout Betting 2 Way": "Bout Betting 2 Way",
      "Round Betting": "Round Betting",
      "Puck Line Handicap": "Puck Line Handicap",
      "Total Match Goals": "Total Match Goals",
      "Run Line": "Run Line",
      "Total Runs": "Total Runs",
      "Race Winner": "Race Winner",
      "90 Minutes": "90 Minutes",
      "Correct Score": "Correct Score",
      "First Goalscorer": "First Goalscorer",
      Outright: "Outright",
      Handicap: "Handicap",
      "Match Winner": "Match Winner",
      "Over/Under": "Over/Under",
      Position: "Position",
      "Full-Time Score": "Full-Time Score",
      Winner: "Winner",
      Match: "Match",
      "(1-3)": "(1-3)"
    },
    wasOddsTemplate: "was {odds}",
    nowOddsTemplate: "now {odds}",
    liveEvent: "Live",
    cta: "Bet Now",
    terms: "<span>Bet Now</span>",
    draw: "Tie",
    sports: {
      basketball: "Basketball",
      baseball: "Baseball",
      football: "Soccer",
      americanFootball: "Football",
      iceHockey: "Ice Hockey",
      tennis: "Tennis",
      golf: "Golf",
      mma: "MMA",
      boxing: "Boxing"
    },
    today: "Today",
    tomorrow: "Tomorrow"
  },
  "es-mx": {
    headerLineOne: "Próximas apuestas",
    headerLineTwo: "",
    marketNames: {
      moneyline: "Línea",
      spread: "Margen",
      totals: "Totales",
      handicapBetting: "Margen",
      matchWinner: "Línea",
      overUnderTotals: "Totales",
      firstGoalscorer: "First Goalscorer",
      competitionWinner: "Competition Winner",
      fullTimeResult: "Línea",
      "NBA Championship Winner": "Ganador del Campeonato NBA",
      "NBA Conference Winner": "Ganador de Conferencia NBA",
      "Money Line": "Línea de dinero",
      Spread: "Margen",
      "Total Points": "Total de Puntos",
      "Conference Winner": "Ganador de Conferencia",
      "Money Line Live": "Línea de dinero en vivo",
      "Odds Boost": "Aumento de probabilidad",
      "Tournament Winner": "Ganador del Torneo",
      "Match Betting": "Apuesta al partido",
      "Bout Betting 2 Way": "Apuesta al combate",
      "Round Betting": "Apuesta al round",
      "Puck Line Handicap": "Handicap Linea de Puck",
      "Total Match Goals": "Total de goles en partido",
      "Run Line": "Línea de carreras",
      "Total Runs": "Total de carreras",
      "Race Winner": "Ganador de carrera",
      "90 Minutes": "90 minutos",
      "First Goalscorer": "Primer anotador",
      Outright: "Completo",
      Handicap: "Handicap",
      "Match Winner": "Partido Ganador",
      "Over/Under": "Más/Menos",
      Position: "Posición",
      "Full-Time Score": "Marcador correcto",
      Winner: "Ganador",
      Match: "Partido",
      "(1-3)": "(1-3)",
      "Correct Score": "Marcador final"
    },
    wasOddsTemplate: "Anter {odds}",
    nowOddsTemplate: "Ahora {odds}",
    liveEvent: "En vivo",
    cta: "Apuesta Ahora",
    terms: "<span>Apuesta Ahora</span>",
    draw: "Empate",
    sports: {
      basketball: "Básquetbol",
      baseball: "Béisbol",
      football: "Fútbol",
      americanFootball: "Fútbol Americano",
      iceHockey: "Hockey",
      tennis: "Tenis",
      golf: "Golf",
      mma: "MMA",
      boxing: "Boxeo"
    },
    today: "Hoy",
    tomorrow: "Mañana"
  }
};

const operatorModifiers: OperatorLanguagesMap = {
  // Whilliam Hill
  "william-hill-us": {
    "en-us": {
      headerLineTwo: "Courtesy of William Hill",
      terms:
        "Odds/lines subject to change. See <a target='_blank'>williamhill.com</a> for details",
      offer: {
        header: "NEW CUSTOMER OFFER",
        body: "GET A $500 RISK FREE BET. USE PROMO CODE: PLAYRF",
        link:
          "https://whus.onelink.me/mi3W?pid=disneyespn&utm_source=disneyespn&af_click=30&ar=prof89820&c=prof89820&utm_campaign=prof89820&af_channel=cpm&utm_medium=cpm&af_c_id=PLAYRF&utm_offer=PLAYRF&bc=PLAYRF&sport=football&league=nfl&af_android_url=https://www.williamhill.com/us/nj/welcome/espn/&​af_ios_url=​https://www.williamhill.com/us/nj/welcome/espn/",
        buttonText: "BET NOW",
        terms:
          "Odds/lines subject to change. See <a target='_blank'>williamhill.com</a> for details"
      }
    },
    "es-mx": {
      headerLineTwo: "Cortesía de William Hill",
      terms:
        "Momios sujetos a cambios. Ver <a target='_blank'>williamhill.com</a> para más detalles",
      offer: {
        header: "OFERTA CLIENTES NUEVOS",
        body:
          "OBTÉN UNA APUESTA DE $500 LIBRE DE RIESGOS UTILIZA CÓDIGO PROMOCIONAL: PLAYRF",
        link:
          "https://whus.onelink.me/mi3W?pid=disneyespn&utm_source=disneyespn&af_click=30&ar=prof89820&c=prof89820&utm_campaign=prof89820&af_channel=cpm&utm_medium=cpm&af_c_id=PLAYRF&utm_offer=PLAYRF&bc=PLAYRF&sport=football&league=nfl&af_android_url=https://www.williamhill.com/us/nj/welcome/espn/&​af_ios_url=​https://www.williamhill.com/us/nj/welcome/espn/",
        buttonText: "APUESTA AHORA",
        terms:
          "Momios sujetos a cambios. Ver <a target='_blank'>williamhill.com</a> para más detalles"
      }
    }
  },
  "william-hill-us-nv": {
    "en-us": {
      headerLineTwo: "Courtesy of William Hill",
      offer: {
        header: "NEW CUSTOMER OFFER",
        body:
          "GET $50 CASH WHEN YOU BET THROUGH $50, WIN OR LOSE. USE PROMO CODE: PLAY50",
        link:
          "https://whus.onelink.me/3Mbu?pid=disneyespn&utm_source=disneyespn&af_click=30&ar=prof89820&c=prof89820&utm_campaign=prof89820&af_channel=cpm&utm_medium=cpm&af_c_id=PLAY50&utm_offer=PLAY50&bc=PLAY50&sport=football&league=nfl&af_android_url=https://www.williamhill.com/us/nv/welcome/espn/&af_ios_url=https://www.williamhill.com/us/nv/welcome/espn/",
        buttonText: "BET NOW",
        terms:
          "Odds/lines subject to change. See <a target='_blank'>williamhill.com</a> for details"
      }
    },
    "es-mx": {
      headerLineTwo: "Cortesía de William Hill",
      offer: {
        header: "OFERTA CLIENTES NUEVOS",
        body:
          "OBTÉN $50 CUANDO APUESTAS OTROS $50, GANES O PIERDAS, USA EL CÓDIGO PROMOCIONAL: PLAY50",
        link:
          "https://whus.onelink.me/3Mbu?pid=disneyespn&utm_source=disneyespn&af_click=30&ar=prof89820&c=prof89820&utm_campaign=prof89820&af_channel=cpm&utm_medium=cpm&af_c_id=PLAY50&utm_offer=PLAY50&bc=PLAY50&sport=football&league=nfl&af_android_url=https://www.williamhill.com/us/nv/welcome/espn/&af_ios_url=https://www.williamhill.com/us/nv/welcome/espn/",
        buttonText: "APUESTA AHORA",
        terms:
          "Momios sujetos a cambios. Ver <a target='_blank'>williamhill.com</a> para más detalles"
      }
    }
  },
  "william-hill-us-il": {
    "en-us": {
      headerLineTwo: "Courtesy of William Hill",
      offer: {
        header: "NEW CUSTOMER OFFER",
        body: "GET A RISK FREE BET UP TO $300, USE PROMO CODE: PLAY300",
        link:
          "https://whus.onelink.me/Rr8X?pid=disneyespn&utm_source=disneyespn&af_click=30&ar=prof89820&c=prof89820&utm_campaign=prof89820&af_channel=cpm&utm_medium=cpm&af_c_id=PLAY300&utm_offer=PLAY300&bc=PLAY300&sport=football&league=nfl&af_android_url=https%3A%2F%2Fwww.williamhill.com%2Fus%2Fil%2Fwelcome%2Fespn&af_ios_url=https%3A%2F%2Fwww.williamhill.com%2Fus%2Fil%2Fwelcome%2Fespn",
        buttonText: "BET NOW",
        terms:
          "Odds/lines subject to change. See <a target='_blank'>williamhill.com</a> for details"
      }
    },
    "es-mx": {
      headerLineTwo: "Cortesía de William Hill",
      offer: {
        header: "OFERTA CLIENTES NUEVOS",
        body:
          "OBTÉN UNA APUESTA DE HASTA $300 LIBRE DE RIESGOS, USAL EL CÓDIGO PROMOCIONAL: PLAY300",
        link:
          "https://whus.onelink.me/Rr8X?pid=disneyespn&utm_source=disneyespn&af_click=30&ar=prof89820&c=prof89820&utm_campaign=prof89820&af_channel=cpm&utm_medium=cpm&af_c_id=PLAY300&utm_offer=PLAY300&bc=PLAY300&sport=football&league=nfl&af_android_url=https%3A%2F%2Fwww.williamhill.com%2Fus%2Fil%2Fwelcome%2Fespn&af_ios_url=https%3A%2F%2Fwww.williamhill.com%2Fus%2Fil%2Fwelcome%2Fespn",
        buttonText: "APUESTA AHORA",
        terms:
          "Momios sujetos a cambios. Ver <a target='_blank'>williamhill.com</a> para más detalles"
      }
    }
  },
  "william-hill-us-in": {
    "en-us": {
      headerLineTwo: "Courtesy of William Hill",
      offer: {
        header: "NEW CUSTOMER OFFER",
        body: "GET A $2,021 RISK FREE BET. USE PROMO CODE: PLAYRF",
        link:
          "https://whus.onelink.me/w7ke?&pid=disneyespn&utm_source=disneyespn&ar=prof812121&c=prof812121&utm_campaign=cpm&utm_medium=cpm&af_c_id=PLAYRF&utm_offer=PLAYRF&bc=PLAYRF&sport=football&league=nfl&zone=espn",
        buttonText: "BET NOW",
        terms:
          "Odds/lines subject to change. See <a target='_blank'>williamhill.com</a> for details"
      }
    },
    "es-mx": {
      headerLineTwo: "Cortesía de William Hill",
      offer: {
        header: "OFERTA CLIENTES NUEVOS",
        body:
          "OBTÉN UNA APUESTA DE $2,021 LIBRE DE RIESGOS UTILIZA CÓDIGO PROMOCIONAL: PLAYRF",
        link:
          "https://whus.onelink.me/w7ke?&pid=disneyespn&utm_source=disneyespn&ar=prof812121&c=prof812121&utm_campaign=cpm&utm_medium=cpm&af_c_id=PLAYRF&utm_offer=PLAYRF&bc=PLAYRF&sport=football&league=nfl&zone=espn",
        buttonText: "APUESTA AHORA",
        terms:
          "Momios sujetos a cambios. Ver <a target='_blank'>williamhill.com</a> para más detalles"
      }
    }
  },
  "william-hill-us-mi": {
    "en-us": {
      headerLineTwo: "Courtesy of William Hill",
      offer: {
        header: "NEW CUSTOMER OFFER",
        body: "GET A $2,021 RISK FREE BET. USE PROMO CODE: PLAYRF",
        link:
          "https://whus.onelink.me/oGCw?&pid=disneyespn&utm_source=disneyespn&ar=prof812121&c=prof812121&utm_campaign=cpm&utm_medium=cpm&af_c_id=PLAYRF&utm_offer=PLAYRF&bc=PLAYRF&sport=football&league=nfl&zone=espn",
        buttonText: "BET NOW",
        terms:
          "Odds/lines subject to change. See <a target='_blank'>williamhill.com</a> for details"
      }
    },
    "es-mx": {
      headerLineTwo: "Cortesía de William Hill",
      offer: {
        header: "OFERTA CLIENTES NUEVOS",
        body:
          "OBTÉN UNA APUESTA DE $2,021 LIBRE DE RIESGOS UTILIZA CÓDIGO PROMOCIONAL: PLAYRF",
        link:
          "https://whus.onelink.me/oGCw?&pid=disneyespn&utm_source=disneyespn&ar=prof812121&c=prof812121&utm_campaign=cpm&utm_medium=cpm&af_c_id=PLAYRF&utm_offer=PLAYRF&bc=PLAYRF&sport=football&league=nfl&zone=espn",
        buttonText: "APUESTA AHORA",
        terms:
          "Momios sujetos a cambios. Ver <a target='_blank'>williamhill.com</a> para más detalles"
      }
    }
  },
  "william-hill-us-va": {
    "en-us": {
      headerLineTwo: "Courtesy of William Hill",
      offer: {
        header: "NEW CUSTOMER OFFER",
        body: "GET A $2,021 RISK FREE BET. USE PROMO CODE: PLAYRF",
        link:
          "https://whus.onelink.me/pNnw?&pid=disneyespn&utm_source=disneyespn&ar=prof82121&c=prof82121&utm_campaign=cpm&utm_medium=cpm&af_c_id=PLAYRF&utm_offer=PLAYRF&bc=PLAYRF&sport=football&league=nfl&zone=espn",
        buttonText: "BET NOW",
        terms:
          "Odds/lines subject to change. See <a target='_blank'>williamhill.com</a> for details"
      }
    },
    "es-mx": {
      headerLineTwo: "Cortesía de William Hill",
      offer: {
        header: "OFERTA CLIENTES NUEVOS",
        body:
          "OBTÉN UNA APUESTA DE $2,021 LIBRE DE RIESGOS UTILIZA CÓDIGO PROMOCIONAL: PLAYRF",
        link:
          "https://whus.onelink.me/pNnw?&pid=disneyespn&utm_source=disneyespn&ar=prof82121&c=prof82121&utm_campaign=cpm&utm_medium=cpm&af_c_id=PLAYRF&utm_offer=PLAYRF&bc=PLAYRF&sport=football&league=nfl&zone=espn",
        buttonText: "APUESTA AHORA",
        terms:
          "Momios sujetos a cambios. Ver <a target='_blank'>williamhill.com</a> para más detalles"
      }
    }
  },
  "william-hill-us-ia": {
    "en-us": {
      headerLineTwo: "Courtesy of William Hill",
      offer: {
        header: "NEW CUSTOMER OFFER",
        body: "GET A $500 RISK FREE BET. USE PROMO CODE: PLAYRF",
        link:
          "https://whus.onelink.me/Z5CE?pid=disneyespn&utm_source=disneyespn&af_click=30&ar=prof89820&c=prof89820&utm_campaign=prof89820&af_channel=cpm&utm_medium=cpm&af_c_id=PLAYRF&utm_offer=PLAYRF&bc=PLAYRF&sport=football&league=nfl&af_android_url=https%3A%2F%2Fwww.williamhill.com%2Fus%2Fia%2Fwelcome%2Fespn%2F&af_ios_url=https%3A%2F%2Fwww.williamhill.com%2Fus%2Fia%2Fwelcome%2Fespn%2F",
        buttonText: "BET NOW",
        terms:
          "Odds/lines subject to change. See <a target='_blank'>williamhill.com</a> for details"
      }
    },
    "es-mx": {
      headerLineTwo: "Cortesía de William Hill",
      offer: {
        header: "OFERTA CLIENTES NUEVOS",
        body:
          "OBTÉN UNA APUESTA DE $500 LIBRE DE RIESGOS UTILIZA CÓDIGO PROMOCIONAL: PLAYRF",
        link:
          "https://whus.onelink.me/Z5CE?pid=disneyespn&utm_source=disneyespn&af_click=30&ar=prof89820&c=prof89820&utm_campaign=prof89820&af_channel=cpm&utm_medium=cpm&af_c_id=PLAYRF&utm_offer=PLAYRF&bc=PLAYRF&sport=football&league=nfl&af_android_url=https%3A%2F%2Fwww.williamhill.com%2Fus%2Fia%2Fwelcome%2Fespn%2F&af_ios_url=https%3A%2F%2Fwww.williamhill.com%2Fus%2Fia%2Fwelcome%2Fespn%2F",
        buttonText: "APUESTA AHORA",
        terms:
          "Momios sujetos a cambios. Ver <a target='_blank'>williamhill.com</a> para más detalles"
      }
    }
  },
  "william-hill-us-co": {
    "en-us": {
      headerLineTwo: "Courtesy of William Hill",
      offer: {
        header: "NEW CUSTOMER OFFER",
        body: "GET A $2,021 RISK FREE BET. USE PROMO CODE: PLAYRF",
        link:
          "https://whus.onelink.me/62T0?&pid=disneyespn&utm_source=disneyespn&ar=prof812121&c=prof812121&utm_campaign=cpm&utm_medium=cpm&af_c_id=PLAYRF&utm_offer=PLAYRF&bc=PLAYRF&sport=football&league=nfl&zone=espn",
        buttonText: "BET NOW",
        terms:
          "Odds/lines subject to change. See <a target='_blank'>williamhill.com</a> for details"
      }
    },
    "es-mx": {
      headerLineTwo: "Cortesía de William Hill",
      offer: {
        header: "OFERTA CLIENTES NUEVOS",
        body:
          "OBTÉN UNA APUESTA DE $2,021 LIBRE DE RIESGOS UTILIZA CÓDIGO PROMOCIONAL: PLAYRF",
        link:
          "https://whus.onelink.me/62T0?&pid=disneyespn&utm_source=disneyespn&ar=prof812121&c=prof812121&utm_campaign=cpm&utm_medium=cpm&af_c_id=PLAYRF&utm_offer=PLAYRF&bc=PLAYRF&sport=football&league=nfl&zone=espn",
        buttonText: "APUESTA AHORA",
        terms:
          "Momios sujetos a cambios. Ver <a target='_blank'>williamhill.com</a> para más detalles"
      }
    }
  },
  "william-hill-us-wv": {
    "en-us": {
      headerLineTwo: "Courtesy of William Hill",
      offer: {
        header: "NEW CUSTOMER OFFER",
        body: "GET A $500 RISK FREE BET. USE PROMO CODE: PLAYRF",
        link:
          "https://whus.onelink.me/2Hg6?pid=disneyespn&utm_source=disneyespn&af_prt=disneyespn&af_click=30&ar=prof89820&c=prof89820&utm_campaign=prof89820&af_channel=cpm&utm_medium=cpm&af_c_id=PLAYRF&utm_offer=PLAYRF&bc=PLAYRF&sport=football&league=nfl&af_android_url=https%3A%2F%2Fwww.williamhill.com%2Fus%2Fwv%2Fwelcome%2Fespn%2F&af_ios_url=https%3A%2F%2Fwww.williamhill.com%2Fus%2Fwv%2Fwelcome%2Fespn%2F",
        buttonText: "BET NOW",
        terms:
          "Odds/lines subject to change. See <a target='_blank'>williamhill.com</a> for details"
      }
    },
    "es-mx": {
      headerLineTwo: "Cortesía de William Hill",
      offer: {
        header: "OFERTA CLIENTES NUEVOS",
        body:
          "OBTÉN UNA APUESTA DE $500 LIBRE DE RIESGOS UTILIZA CÓDIGO PROMOCIONAL: PLAYRF",
        link:
          "https://whus.onelink.me/2Hg6?pid=disneyespn&utm_source=disneyespn&af_prt=disneyespn&af_click=30&ar=prof89820&c=prof89820&utm_campaign=prof89820&af_channel=cpm&utm_medium=cpm&af_c_id=PLAYRF&utm_offer=PLAYRF&bc=PLAYRF&sport=football&league=nfl&af_android_url=https%3A%2F%2Fwww.williamhill.com%2Fus%2Fwv%2Fwelcome%2Fespn%2F&af_ios_url=https%3A%2F%2Fwww.williamhill.com%2Fus%2Fwv%2Fwelcome%2Fespn%2F",
        buttonText: "APUESTA AHORA",
        terms:
          "Momios sujetos a cambios. Ver <a target='_blank'>williamhill.com</a> para más detalles"
      }
    }
  },
  "william-hill-us-tn": {
    "en-us": {
      headerLineTwo: "Courtesy of William Hill",
      offer: {
        header: "NEW CUSTOMER OFFER",
        body: "GET A $2,021 RISK FREE BET. USE PROMO CODE: PLAYRF",
        link:
          "https://whus.onelink.me/T17m?&pid=disneyespn&utm_source=disneyespn&ar=prof831121&c=prof831121&utm_campaign=cpm&utm_medium=cpm&af_c_id=PLAYRF&utm_offer=PLAYRF&bc=PLAYRF&sport=football&league=nfl&zone=espn",
        buttonText: "BET NOW",
        terms:
          "Odds/lines subject to change. See <a target='_blank'>williamhill.com</a> for details"
      }
    },
    "es-mx": {
      headerLineTwo: "Cortesía de William Hill",
      offer: {
        header: "OFERTA CLIENTES NUEVOS",
        body:
          "OBTÉN UNA APUESTA DE $2,021 LIBRE DE RIESGOS UTILIZA CÓDIGO PROMOCIONAL: PLAYRF",
        link:
          "https://whus.onelink.me/T17m?&pid=disneyespn&utm_source=disneyespn&ar=prof831121&c=prof831121&utm_campaign=cpm&utm_medium=cpm&af_c_id=PLAYRF&utm_offer=PLAYRF&bc=PLAYRF&sport=football&league=nfl&zone=espn",
        buttonText: "APUESTA AHORA",
        terms:
          "Momios sujetos a cambios. Ver <a target='_blank'>williamhill.com</a> para más detalles"
      }
    }
  },

  // Draftkings
  draftkings: {
    "en-us": {
      headerLineTwo: "Odds courtesy of DraftKings",
      terms:
        "Odds/lines subject to change. T&Cs apply. See <a target='_blank'>draftkings.com</a> for details.",
      offer: {
        header: "MAKE YOUR FIRST BET COUNT",
        body: "Get a bonus up to $1,000 with first deposit.",
        link:
          "https://ad.doubleclick.net/ddm/trackclk/N1177992.3808125ESPNSPORTS/B24649382.282203071;dc_trk_aid=476079097;dc_trk_cid=137597799;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755}?https://dksb.sng.link/As9kz/gmv0?_dl=dksb%3A%2F%2Fsb%2Fhome&pcn=OddsLinkOut_9.13&psn=ESPN&pcid=100403",
        buttonText: "Get Your Bonus",
        terms:
          "Odds/lines subject to change. T&Cs apply. See <a target='_blank'>draftkings.com/sportsbook</a> for details."
      }
    },
    "es-mx": {
      headerLineTwo: "Momios cortesía de DraftKings",
      terms:
        "Momios/líneas sujetos a cambios. Términos y condiciones pueden ser aplicados. Consulta <a target='_blank'>draftkings.com</a> para más detalles.",
      offer: {
        header: "HAZ QUE TU PRIMERA APUESTA VALGA LA PENA",
        body: "Obtén un bono de hasta $1,000 con tu primer depósito",
        link:
          "https://ad.doubleclick.net/ddm/trackclk/N1177992.3808125ESPNSPORTS/B24649382.282203071;dc_trk_aid=476079097;dc_trk_cid=137597799;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;gdpr=${GDPR};gdpr_consent=${GDPR_CONSENT_755}?https://dksb.sng.link/As9kz/gmv0?_dl=dksb%3A%2F%2Fsb%2Fhome&pcn=OddsLinkOut_9.13&psn=ESPN&pcid=100403",
        buttonText: "Obtén tu bono",
        terms:
          "Las líneas de apuestas están sujetas a cambios. Aplican términos y condiciones. Visita <a target='_blank'>sportsbook.draftkings.com/sportsbook</a> para más detalles."
      }
    }
  },
  "draftkings-in": {},
  "draftkings-pa": {},
  "draftkings-co": {},
  "draftkings-il": {},
  "draftkings-ia": {},
  "draftkings-nh": {},
  "draftkings-wv": {},
  "draftkings-tn": {}
};

function operatorSwitch(operator: string) {
  switch (true) {
    case operator.includes("william-hill"): {
      return operatorModifiers["william-hill-us"];
    }
    case operator.includes("draftkings"): {
      return operatorModifiers["draftkings"];
    }
    default: {
      return false;
    }
  }
}

export function getValue(
  operator: OperatorKeys,
  language: LanguageCodes,
  key: keyof Language
) {
  // specific state and languae copy
  if (operatorModifiers[operator]?.[language]?.[key]) {
    return operatorModifiers[operator]?.[language]?.[key];
  }

  // default copy for operators
  const operatorModifier = operatorSwitch(operator)?.[language]?.[key];
  if (operatorModifier) {
    return operatorModifier;
  }

  if (languages[language]?.[key]) {
    return languages[language][key];
  }

  return languages["en-us"][key];
}

export function normaliseEspnLanguageCode(lang: string | null): LanguageCodes {
  if (lang === "de") {
    return "es-mx";
  }

  if (lang === "es-mx") {
    return "es-mx";
  }

  if (lang === "es") {
    return "es-mx";
  }

  if (lang === "us") {
    return "en-us";
  }

  return "en-us";
}

export function getLanugeCodeFromUrl() {
  const addr = new URL(window.location.href);
  const langCode = addr.searchParams.get("lang");
  return normaliseEspnLanguageCode(langCode);
}
